import Vue from 'vue';
import Vuex from 'vuex';
import {VUEX_DEFAULT_CONFIG} from '@/config';
import commonStore from '@/service/store/common';
// import Login from "@/store/login";
// import Chat from "@/store/chat";
// import FriendModule from "@/store/friendModule";
// import Group from "@/store/group";
// import Emedia from "@/store/emedia";

Vue.use(Vuex);

const vuexInstance = new Vuex.Store({
  modules: {
    // login: Login,
    // chat: Chat,
    // friendModule: FriendModule,
    // group: Group,
    // emedia: Emedia,
    common: commonStore
  }
  // ...commonStore,
  // ...VUEX_DEFAULT_CONFIG
});
export default vuexInstance;
